<!-- 树节点 -->
<template>
  <div
    class="yxtbiz-category-tree-node"
    :key="data.nodeId"
    :draggable="showSort"
    @dragstart.stop="handleDragStart"
    @dragover.stop="handleDragOver"
    @dragenter.stop="draggingTag = false"
    @dragleave.stop="draggingTag = false"
    @drop.stop="handleDrop"
  >
    <!-- 当前节点 -->
    <div class="drag-line" v-show="draggingTag && dragDerection === 'up'"></div>
    <div
      class="yxtbiz-category-tree-node-item"
      @click="onClick"
      :class="{
        'is-active': state.active
      }"
      :style="'padding-left: ' + (20 * index + 8) + 'px'"
    >
      <yxt-svg
        icon-class="sort"
        v-if="showSort"
        class="color-gray-6 sort-svg"
        width="16px"
        height="16px"
      ></yxt-svg>
      <span @click.stop="changeExpanded(!expanded)">
        <yxt-svg
          :class="{
            visible: data.hasChild
          }"
          :icon-class="expanded ? 'down' : 'common_right'"
          class="expand-svg color-gray-6 hover-primary-6 hover-pointer"
          width="16px"
          height="16px"
        ></yxt-svg>
      </span>
      <div class="ml4 mr4" v-if="multiple">
        <yxt-checkbox
          v-model="state.checked"
          @change="handleChecked"
        ></yxt-checkbox>
      </div>

      <div class="node-name ml4">
        {{ data.nodeName }}
      </div>
      <yxt-dropdown
        trigger="hover"
        custom-elm
        @command="handleSetting"
        v-if="showInsert || showModified || showDelete"
      >
        <div class="setting-svg hover-primary-6 hover-pointer color-gray-6">
          <i class="yxt-icon-setting"></i>
        </div>

        <yxt-dropdown-menu slot="dropdown">
          <yxt-dropdown-item command="create" v-if="showInsert">{{
            $t('pc_common_category_insert').d('新增')
          }}</yxt-dropdown-item>
          <yxt-dropdown-item command="update" v-if="showModified">{{
            $t('pc_common_cate_edit').d('编辑')
          }}</yxt-dropdown-item>
          <yxt-dropdown-item command="delete" v-if="showDelete">{{
            $t('pc_common_category_delete').d('删除')
          }}</yxt-dropdown-item>
        </yxt-dropdown-menu>
      </yxt-dropdown>
    </div>
    <!-- 遍历子节点 -->
    <div
      v-if="data.hasChild"
      class="yxtbiz-category-tree-node-child-container"
      v-show="expanded"
    >
      <yxtbiz-category-tree-node
        :sort="sort"
        :deleteFunc="deleteFunc"
        :get-cate-children="getCateChildren"
        :handle-click="handleClick"
        :handle-check="handleCheck"
        :showForm="showForm"
        :selectedId="selectedId"
        :checkedIds="checkedIds"
        :afterDelete="handleDeleteChild"
        @dragStart="handleDragItemStart"
        :pnodeId="data.nodeId"
        v-for="item in data.children"
        :data="item"
        :index="index + 1"
        :key="item.nodeId"
        :multiple="multiple"
        :expandAll="expandAll"
        :sortable="sortable"
        :firstModifiable="firstModifiable"
        :modifiable="modifiable"
      ></yxtbiz-category-tree-node>
    </div>
    <div
      class="drag-line"
      v-show="draggingTag && dragDerection === 'down'"
    ></div>
  </div>
</template>

<script>
import EventBus from '../eventBus';
export default {
  name: 'yxtbiz-category-tree-node',
  data() {
    return {
      expanded: false, // 是否展开
      // active: false, // 是否选中高亮
      draggingTag: false, // 是否展示拖拽的蓝线
      childActive: false,
      state: {
        active: false,
        checked: false,
        disabled: false,
        nodeId: '',
        nodeName: ''
      },
      dragDerection: ''
    };
  },

  props: {
    data: {
      type: Object,
      required: true
    },
    pnodeId: {
      type: String,
      default: ''
    },
    selectedId: {
      type: String,
      default: '' // 单选-默认选中的分类nodeId
    },
    checkedIds: {
      type: Array,
      default: () => {
        return [];
      }
    },
    multiple: {
      type: Boolean,
      default: false
    },
    // 是否展开全部子分类
    expandAll: {
      type: Boolean,
      default: () => {
        return false;
      }
    },
    // 是否展开当前分类
    expandedDefault: {
      type: Boolean,
      default: false
    },
    sortable: {
      type: Boolean,
      default: true
    },
    firstModifiable: {
      type: Boolean,
      default: true
    },
    modifiable: {
      type: Object,
      default: () => {
        return {
          add: true,
          delete: true,
          modify: true
        };
      }
    },
    handleClick: {
      type: Function
    },
    handleCheck: {
      type: Function
    },
    showForm: {
      type: Function
    },
    afterDelete: {
      type: Function
    },
    getCateChildren: {
      type: Function
    },
    sort: {
      type: Function
    },
    deleteFunc: {
      type: Function
    },
    // 当前node的层级-前端界面展示的层级，不是数据库中的层级
    index: {
      type: Number
    }
  },
  watch: {
    expandAll(v) {
      if (v && this.data.hasChild && this.data.children.length) {
        this.changeExpanded(true);
      } else {
        this.changeExpanded(false);
      }
    },
    checkedIds() {
      // this.init();
    },
    selectedId() {
      this.initActiveState();
    },
    data() {
      this.init();
    }
  },

  computed: {
    // 是否展示新增按钮
    showInsert() {
      if (!this.data.depth) return this.firstModifiable;
      else if (this.data.depth === 20) return false;
      else if (this.data.children && this.data.children.length > 999)
        return false;
      else if (
        this.modifiable.add === undefined ||
        this.modifiable.add === null
      ) {
        return true;
      } else {
        return !!this.modifiable.add;
      }
    },
    // 是否展示编辑按钮
    showModified() {
      if (!this.data.depth) return false;
      else if (this.data.depth === 1) return this.firstModifiable;
      else if (
        this.modifiable.modify === undefined ||
        this.modifiable.modify === null
      ) {
        return true;
      } else return !!this.modifiable.modify;
    },
    // 是否展示删除按钮
    showDelete() {
      if (!this.data.depth) return false;
      if (this.data.depth === 1) return this.firstModifiable;
      else if (
        this.modifiable.delete === undefined ||
        this.modifiable.delete === null
      ) {
        return true;
      } else return !!this.modifiable.delete;
    },
    showSort() {
      return this.sortable && this.data.depth > 0;
    }
  },
  created() {
    this.init();
    // console.log(
    //   '开始监听事件' + this.data.nodeName + '：' + 'refresh-' + this.data.nodeId
    // );
    EventBus.$on('refresh-' + this.data.nodeId, this.refresh);
  },
  beforeDestroy() {
    // console.log('移除监听事件：' + 'refresh-' + this.data.nodeId);
    EventBus.$off('refresh-' + this.data.nodeId, this.refresh);
  },
  methods: {
    // 更新子节点
    refresh({ isAdd, data, nodeId }) {
      if (isAdd) {
        data.depth = (this.data.depth || 0) + 1;
        if (
          (this.data.hasChild && this.data.children.length) ||
          this.expanded
        ) {
          this.data.children.push(data);
        }
        this.data.hasChild = true;
      } else {
        if (this.data.hasChild && this.data.children.length) {
          const index = this.data.children.findIndex(
            item => item.nodeId === nodeId
          );
          if (index > -1) this.data.children.splice(index, 1);
        }
        this.data.hasChild = this.data.children.length > 0;
        if (!this.data.hasChild) {
          this.expanded = false;
        }
      }
    },
    init() {
      this.state.nodeId = this.data.nodeId;
      this.state.nodeName = this.data.nodeName;
      this.initActiveState();
      if (
        this.expandedDefault ||
        (this.expandAll && this.data.hasChild && this.data.children.length)
      ) {
        this.changeExpanded(true);
      } else {
        this.changeExpanded(false);
      }
    },
    initActiveState() {
      if (this.multiple) {
        this.state.checked = this.checkedIds.includes(this.data.nodeId);
        this.state.checked && this.handleCheck(true, this.state, 0);
      } else {
        this.state.active = this.selectedId === this.data.nodeId;
        this.state.active && this.handleClick(this.state, 0);
      }
    },
    onClick(e) {
      if (e && e.target) {
        // 点击展开按钮或者设置按钮停止事件冒泡
        if (
          e.target.classList.contains('expand-svg') ||
          e.target.classList.contains('yxt-icon-setting')
        ) {
          e.preventDefault();
          return;
        }
      }
      if (this.multiple) return;
      this.handleClick(this.state);
    },
    // 勾选
    handleChecked(v) {
      this.handleCheck(v, this.state);
    },
    async changeExpanded(v) {
      this.expanded = v;
      if (!this.data.hasChild) return;
      // 第一次展开获取数据
      if (v && (!this.data.children || !this.data.children.length)) {
        await this.getChildren();
      }
    },
    async getChildren() {
      try {
        const { node } = await this.getCateChildren(this.data.nodeId);
        this.data.nodeName = node.nodeName;
        this.data.hasChild = node.hasChild;
        this.data.children = node.children;
      } catch (error) {}
    },
    // 子节点拖拽后
    handleDragItemStart() {
      this.$store.dispatch('setDragList', this.data.children);
      this.$store.dispatch('setDragParentId', this.data.nodeId);
    },
    // 开始拖拽
    handleDragStart(e) {
      this.dragDerection = '';
      e.dataTransfer.setData('node_data', JSON.stringify(this.data));
      this.$store.dispatch('setDragStart', {
        nodeId: this.data.nodeId,
        y1: e.clientY
      });
      this.$emit('dragStart');
    },
    handleDragOver(e) {
      // 同一个父节点下的子节点允许拖动,展示标识线条
      // 通过相对竖直位移判断当前的移动方向，来判断移动到当前节点的上面或下面
      const dragState = this.$store.state.dragState;
      const y2 = e.clientY;
      if (
        dragState.nodeId === this.data.nodeId ||
        this.$store.state.dragParentId !== this.pnodeId
      ) {
        this.dragDerection = '';
        this.draggingTag = false;
        e.preventDefault();
        return;
      }
      this.dragDerection = y2 > dragState.y1 ? 'down' : 'up';
      this.draggingTag = true;
      e.preventDefault();
    },
    // 释放修改数据
    // 被拖拽的数据 data, 释放的数据： this.data
    async handleDrop(e) {
      try {
        if (!this.draggingTag || !this.dragDerection) return;
        e.preventDefault();
        this.draggingTag = false;
        const data = JSON.parse(e.dataTransfer.getData('node_data') || '');
        if (data.nodeId === this.data.nodeId) return;
        const parentList = this.$store.state.dragList;
        // 位置未发生变化则不处理
        let prevNodeId, nextNodeId;
        const fromIndex = parentList.findIndex(
          item => item.nodeId === data.nodeId
        );
        const toIndex = parentList.findIndex(
          item => item.nodeId === this.data.nodeId
        );

        // 上移
        if (this.dragDerection === 'up') {
          prevNodeId = parentList[toIndex - 1]
            ? parentList[toIndex - 1].nodeId
            : '';
          nextNodeId = this.data.nodeId;
        } else {
          // 下移
          prevNodeId = this.data.nodeId;
          nextNodeId = parentList[toIndex + 1]
            ? parentList[toIndex + 1].nodeId
            : '';
        }

        await this.sort({
          nodeId: data.nodeId,
          prevNodeId,
          nextNodeId
        });

        const item = parentList.splice(fromIndex, 1)[0];
        parentList.splice(toIndex, 0, item);
      } catch (e) {
        if (e && e.error) {
          this.$message.error(e.error.message || this.$t('pc_common_category_error_02').d('排序失败'));
        } else {
          this.$message.error(this.$t('pc_common_category_error_02').d('排序失败'));
        }
      }
    },

    // 设置
    async handleSetting(type) {
      if (type === 'delete') {
        try {
          await this.$confirm(
            this.$t('pc_common_category_error_01').d('删除后，数据不可恢复，请谨慎操作！'),
            this.$t('pc_common_cate_delete_confirm').d('确定删除该分类吗'),
            {
              type: 'warning'
            }
          );
          await this.deleteFunc({
            nodeId: this.data.nodeId
          });
          this.$message.success(this.$t('pc_gwnl_global_msg_deleteSuccess').d('删除成功!'));
          this.afterDelete(this.data.nodeId);
        } catch (e) {
          e && e.error && this.$message.error(e.error.message || this.$t('pc_gwnl_eval_error_question_deletefailed').d('删除失败'));
        }
      } else {
        this.showForm({
          nodeId: this.data.nodeId,
          nodeName: this.data.nodeName,
          type: type,
          callback: this.callback
        });
      }
    },
    callback(res) {
      // this.getChildren();
      // this.$parent.getChildren();
      if (res.nodeId === this.data.nodeId) {
        // 编辑
        this.data.nodeName = res.name;
        // 所属分类发生变化，则需要更新原父分类和新父分类的子节点
        if (this.pnodeId !== res.pnodeId) {
          // console.log('触发事件：删除子节点  ' + 'refresh-' + this.pnodeId);
          EventBus.$emit('refresh-' + this.pnodeId, {
            isAdd: false,
            nodeId: this.data.nodeId
          });
          // console.log('触发事件：新增子节点' + 'refresh-' + res.pnodeId);
          EventBus.$emit('refresh-' + res.pnodeId, {
            isAdd: true,
            data: this.data
          });
        }
      } else {
        // 新增
        EventBus.$emit('refresh-' + res.pnodeId, {
          isAdd: true,
          data: {
            nodeId: res.nodeId,
            nodeName: res.name || res.nodeName,
            hasChild: false,
            children: []
          }
        });
      }
    },
    handleDeleteChild(nodeId) {
      const index = this.data.children.findIndex(
        item => item.nodeId === nodeId
      );
      this.data.children.splice(index, 1);
      if (!this.data.children.length) {
        this.data.hasChild = false;
        this.expanded = false;
      }
    }
  }
};
</script>
